import angular from 'angular';
import _ from 'lodash';
import template from './template.html';
import './style.scss';

export class CandidateLinkProfile {
    candidateLinkedinUrl = '';

    hideOriginalButtons = true;

    $onChanges() {
        const candidate = this.candidate;
        const { url = this.candidateLinkedinUrl } = this.getCandidateLinkedinUrl(candidate) || {};

        this.candidateLinkedinUrl = url;
    }

    getCandidateLinkedinUrl(candidate) {
        const webAddress = _.get(candidate, 'candidateData.contact.webAddress', null);

        if (!webAddress) {
            return undefined;
        }

        return _.find(webAddress, { type: 'linkedin' });
    }
}

export const candidateLinkProfileConfiguration = {
    template,
    bindings: {
        candidate: '<',
    },
    controller: CandidateLinkProfile,
    controllerAs: 'candidateLinkProfileCtrl',
};

angular.module('TALENYA-FE').component('candidateLinkProfile', candidateLinkProfileConfiguration);
